import type React from 'react';

import { Badge } from '@vlabs/uikit';

import st from './AppliedFiltersBadge.module.sass';

interface AppliedFiltersBadgeProps {
  count?: number;
  isApplied?: boolean;
  isEnabled: boolean;
}

function AppliedFiltersBadge({
  count = undefined,
  isApplied = false,
  isEnabled,
}: AppliedFiltersBadgeProps): React.JSX.Element | null {
  const isVisible = count !== undefined ? count > 0 : isApplied;
  if (!isVisible) return null;

  return (
    <div className={st.AppliedFiltersBadge}>
      <Badge
        kind={isEnabled ? 'primary' : 'neutral'}
        shape={count === undefined ? 'dot' : 'round'}
        value={count}
      />
    </div>
  );
}

export { AppliedFiltersBadge };
